import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { PersonalNoteContentCollection } from '../index'

/**
 * Setup bidirectional replication for personal note content with WebSocket real-time updates.
 * Separate from personal note replication for version-based conflict resolution.
 */
export const setupPersonalNoteContentReplication = (
  collection: PersonalNoteContentCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'personalnotecontents',
    apiEntityName: 'personalNoteContents',
    displayName: 'PersonalNoteContent',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      personalNoteId: doc.personalNoteId,
      envId: doc.envId,
      isDeleted: doc.isDeleted || false,
      content: doc.content || '',
      format: doc.format || 'tiptap',
      length: doc.length || 0,
      plainText: doc.plainText,
      version: doc.version || 1,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      personalNoteId: state.personalNoteId,
      envId,
      isDeleted: state.isDeleted || false,
      content: state.content || '',
      format: state.format || 'tiptap',
      length: state.length || 0,
      plainText: state.plainText,
      version: state.version || 1,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy || null,
    }),
  })
